// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8bDOf","type":"styles_type__GSYOV","choices":"styles_choices__1Z26G"};